(function() {
  document.querySelectorAll("[data-whop-plan]").forEach(function(btn) {
    var planId = btn.getAttribute("data-whop-plan");
    var uid = planId.replace("plan_", "wp");

    var overlay = document.createElement("div");
    overlay.className = "whop-overlay";
    overlay.id = "modal-" + uid;
    overlay.innerHTML = '<div class="whop-box"><button type="button" class="whop-x" data-whop-close="' + uid + '">&times;</button><div class="whop-frame" id="frame-' + uid + '"></div></div>';
    document.body.appendChild(overlay);

    var loaded = false;

    btn.addEventListener("click", function() {
      if (!loaded) {
        var f = document.createElement("iframe");
        f.src = "https://whop.com/checkout/" + planId + "/";
        f.allow = "payment";
        f.title = "Subscribe";
        document.getElementById("frame-" + uid).appendChild(f);
        loaded = true;
      }
      overlay.classList.add("open");
      document.body.style.overflow = "hidden";
    });

    overlay.querySelector("[data-whop-close]").addEventListener("click", function() {
      overlay.classList.remove("open");
      document.body.style.overflow = "";
    });

    overlay.addEventListener("click", function(e) {
      if (e.target === overlay) {
        overlay.classList.remove("open");
        document.body.style.overflow = "";
      }
    });
  });
})();
